import { render, staticRenderFns } from "./SkinChipLinkMarket.vue?vue&type=template&id=161424a4&scoped=true&"
import script from "./SkinChipLinkMarket.vue?vue&type=script&lang=ts&"
export * from "./SkinChipLinkMarket.vue?vue&type=script&lang=ts&"
import style0 from "./SkinChipLinkMarket.vue?vue&type=style&index=0&id=161424a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161424a4",
  null
  
)

export default component.exports